var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDividerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 374,
    height: 1,
    viewBox: "0 0 374 1",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H373.5",
    stroke: "#ECF0F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerIcon);
export default __webpack_public_path__ + "static/media/divider-icon.06aa5cc7710a2ab8bbb03bfee4161bca.svg";
export { ForwardRef as ReactComponent };